import { Component, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource, MatPaginator } from "@angular/material";
import { FuncionariosService } from "../servicios/funcionarios.service";
import { Globals } from "src/app/globals";

@Component({
  selector: "app-lista-enviados",
  templateUrl: "./lista-enviados.component.html",
  styleUrls: ["./lista-enviados.component.css"]
})
export class ListaEnviadosComponent implements OnInit {
  dataSource = new MatTableDataSource([]);

  loading = true;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  displayedColumns: string[] = ["nombre_completo", "correo_corporativo", "nombre_posicion", "fecha_envio","fecha_registro"];

  funcionariosok = null;

  constructor(private funcionarioService: FuncionariosService, public globals: Globals) {}

  ngOnInit() {
    this.ConsultarTodosLosFuncionarios();

    //////conole.log(this.globals.contenedorVarGlobal);
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  ConsultarTodosLosFuncionarios() {
    this.funcionarioService.ConsultarEnviados().subscribe(result => {
      this.funcionariosok = result;
      //////conole.log(result);
      this.dataSource = new MatTableDataSource(this.funcionariosok);
      this.dataSource.paginator = this.paginator;
      this.loading = false;
    });
  }

  seleccionarusuario(IdusuarioSapFrontera) {
    //////conole.log(IdusuarioSapFrontera);

    this.globals.contenedorVarGlobal = "formulario";
    this.globals.tipoFormularioVarGlobal = "Editar";

    //localStorage.getItem("IdusuarioSapFrontera");
    localStorage.setItem("IdusuarioSapFrontera", IdusuarioSapFrontera);
  }
}
